import { Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './style.css';
import images from 'assets/images';
import type { IAuthoriseSessionProps } from '../../types/propTypes';
import { useAuthoriseSessionHook } from './hooks/AuthoriseSessionHook';

const AuthoriseSession = (props: IAuthoriseSessionProps) => {
    const { t } = useAuthoriseSessionHook(props);

    return (
        <>
            <Helmet>
                <title>{t<string>('authoriseSession.title')}</title>
            </Helmet>
            <div className="authorise-session">
                <div className="charge-auth-img-div">
                    <img className="charge-auth-img" src={images.icChargeAuthIcon} alt="charge auth" />
                </div>
                <div className="info-text">
                    <span>{t<string>('authoriseSession.info')}</span>
                </div>
                <div className="loader-div">
                    <Spinner animation={'border'} />
                </div>
                <div className="instructions">
                    <div className="instruction-title">
                        <h6 className="sub-title">{t<string>('authoriseSession.nextSteps')}</h6>
                    </div>
                    <div className="row no-gutters justify-content-between instruction-card-wrapper">
                        <div className="col-12 instruction-card">
                            <div className="instruction-card-header">
                                <div className="number-circle">1</div>
                            </div>
                            <div className="instruction-body">
                                <div className="instruction-img-div col-xs-3">
                                    <img src={images.icPlugInVerySmallIcon} className="instruction-img" alt="charger" />
                                </div>
                                <div className="instruction-text-div col-xs-9">
                                    {t<string>('authoriseSession.plugInVehicle')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters justify-content-between instruction-card-wrapper pb-30p">
                        <div className="col-12 instruction-card">
                            <div className="instruction-card-header">
                                <div className="number-circle">2</div>
                            </div>
                            <div className="instruction-body">
                                <div className="instruction-img-div col-xs-3">
                                    <img src={images.icTeaCupIcon} className="instruction-img" alt="tea cup" />
                                </div>
                                <div className="instruction-text-div col-xs-9">
                                    {t<string>('authoriseSession.chargeSession')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AuthoriseSession;
